import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import {
  DELETE_TYPE,
  GETALL_TYPE,
  GETBYGUID_TYPE,
} from "../../../_contstants/common";

export const getAllAddictions = createAsyncThunk(
  "getAllAddiction/ManageAddiction",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/ManageAddictions`,
        {
          Name: "",
          OperationType: GETALL_TYPE,
        }
      );
      if (response.data.Status === 200) {
        return response.data?.Data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      console.error("Error Fetching Addictions:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createAddiction = createAsyncThunk(
  "createAddiction/ManageAddiction",
  async (AddictionData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/ManageAddictions`,
        AddictionData
      );
      if (response.data.Status === 201) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Inserting Addiction:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateAddiction = createAsyncThunk(
  "updateAddiction/ManageAddiction",
  async (AddictionData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/ManageAddictions`,
        AddictionData
      );
      if (response.data.Status === 200) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Updating Addiction:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteAddiction = createAsyncThunk(
  "deleteAddiction/ManageAddiction",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/ManageAddictions`,
        {
          AddictionsGUID: ID,
          OperationType: DELETE_TYPE,
        }
      );
      if (response.data.Status === 200) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting Addiction:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAddictionById = createAsyncThunk(
  "getAddictionById/ManageAddiction",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/ManageAddictions`,
        {
          AddictionsGUID: ID,
          OperationType: GETBYGUID_TYPE,
        }
      );
      const result = response.data?.Data[0] as any;
      return {
        ID: result?.ID,
        AddictionsGUID: result?.AddictionsGUID,
        Name: result?.Name,
        IsActive: result?.IsActive === true ? 1 : 2,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Addiction:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveAddiction = createAsyncThunk(
  "Master/ManageAddiction",
  async (AddictionData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/ManageAddictions`,
        AddictionData
      );
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fetching Addiction:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const activeInactiveAddiction = createAsyncThunk(
  "AddictionActiveInactive/ManageAddiction",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/ManageAddictions`,
        formData
      );
      if (response.data.Status === 200) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Addiction:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
